import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {useMemo} from 'react'
import {GZ911} from './GZ911'

const KNOWN_WIDGETS: Record<string, (props: any) => JSX.Element> = {
  GZ911,
}

export const LocalExperts = () => {
  const variations = EnvironmentProvider.useVariations()

  const widgetsData = useMemo(() => {
    const widgetsData = []
    const usedWidgetCodes = Object.keys(variations?.conditions ?? {}).filter((code) => code.startsWith('localExperts'))

    for (const widgetCode of usedWidgetCodes) {
      const widgetId = widgetCode.split(':')[1]

      if (!widgetId) {
        console.warn(`Invalid widget code, code '${widgetCode}'`)
        continue
      }

      const widget = KNOWN_WIDGETS[widgetId]

      if (!widget) {
        console.warn(`Unknown widget, code '${widgetCode}'`)
        continue
      }

      const conditionConfig = variations?.conditions[widgetCode]

      if (!Boolean(conditionConfig)) {
        continue
      }

      const widgetConfig = variations?.widgets[widgetCode]

      if (!widgetConfig) {
        console.warn(`Unknown widget config, code '${widgetCode}'`)
        continue
      }

      widgetsData.push({
        Component: widget,
        config: widgetConfig,
        code: widgetCode,
      })
    }

    return widgetsData
  }, [variations])

  if (!variations) {
    return null
  }

  if (widgetsData.length === 0) {
    return <>Personal stories and insider travel tips</>
  }

  return (
    <>
      {widgetsData.map(({Component, config, code}) => {
        return <Component key={code} config={config} />
      })}
    </>
  )
}
